import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { editaTurnosDisponibles } from "../../../context/Actions/turnos/turnosDisponibles";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import camelize from "../../../../global/utils/camelize";
import DropdownCheck from "../../Genericos/DropdownCheck/DropdownCheck";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FiltrosTurnosPcr.css";
import { parseFiltros } from "../../../../global/utils/parseFilter";

const FiltrosTurnosPcr = ({
  titulo,
  dissmiss,
  handleClickBuscar,
  handleClickProximos,
  handleChangeDatePicker,
  flgExcedeBusq,
  fecha,
}) => {
  const { turnosDisponiblesState, turnosDisponiblesDispatch } =
    useContext(PortalContext);

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0) {
      let centro = [
        ...new Set(
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.map(
            (item) => item.centro
          )
        ),
      ];
      const map = new Map();
      for (const item of centro) {
        if (
          !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.filter(
            (x) => x.descripcion === item
          ).length > 0
        ) {
          if (!map.has(item)) {
            map.set(item);
            //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
            const lastItem =
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .centros[
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                  .centros.length - 1
              ];
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.push(
              {
                id: lastItem.id + 1,
                descripcion: item,
                checked: true,
              }
            );
          }
        }
      }
    }
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  useEffect(() => {
    if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0) {
      let especialistas = [
        ...new Set(
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.map(
            (item) => (item.medico !== null ? item.medico : item.recepcion)
          )
        ),
      ];
      const map = new Map();
      for (const item of especialistas) {
        if (
          !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.filter(
            (x) => camelize(x.descripcion) === camelize(item)
          ).length > 0
        ) {
          if (!map.has(item)) {
            map.set(item);
            const lastItem =
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .especialistas[
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                  .especialistas.length - 1
              ];
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.push(
              {
                id: lastItem.id + 1,
                descripcion: camelize(item),
                checked: true,
              }
            );
          }
        }
      }
    }
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  const handleChangeCentros = (centroArrx) => {
    let origenLabo =
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO";
    if (origenLabo) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    } else {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centros: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    }
  };

  const handleChangeDia = (diaSemArrx) => {

    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: diaSemArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeRango = (rangoArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        rangoHorario: rangoArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-filtrosTurnos-container">
        <div className="ptur-filtrosTurnos-checkCentro-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Centros"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeCentros}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .centros.length
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .centros
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-checkFecha-box">
          <DatePicker
            fechaInicial={`${hoyDia.getFullYear()} ${
              hoyDia.getMonth() + 1
            } ${hoyDia.getDate()}`}
            fechaFinal={`${noventaDiasDespues.getFullYear()} ${
              noventaDiasDespues.getMonth() + 1
            } ${noventaDiasDespues.getDate()}`}
            onChange={handleChangeDatePicker}
            customCss={"ptur-headerBarFiltros-filtros-datePicker"}
            selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
          />
        </div>
        <div className="ptur-filtrosTurnos-checkDia-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Día semanal"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeDia}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .diasKin.length
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .diasKin
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-checkRango-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Horarios"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeRango}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .rangoHorario.length
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .rangoHorario
            }
          />
        </div>

        <div className="ptur-filtrosTurnos-btn-box">
          <button
            className="ptur-filtrosTurnos-btnBuscar c-white rb18m"
            onClick={handleClickBuscar}
          >
            Buscar
          </button>

          <div className="ptur-filtrosTurnos-divsores-box">
            <div className="ptur-filtrosTurnos-divsor"></div>
            <span className="ptur-filtrosTurnos-divsores-txt rb12m">
              o buscar por
            </span>
            <div className="ptur-filtrosTurnos-divsor"></div>
          </div>

          <button
            className="ptur-filtrosTurnos-btnProx c-latex30 rb16m"
            onClick={handleClickProximos}
          >
            {!flgExcedeBusq
              ? "Próximos turnos disponibles"
              : "Reiniciar búsqueda"}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FiltrosTurnosPcr;
